<template>
  <div class="window win-card header-bar" style="display: grid; grid-template-columns: 1fr; grid-template-rows:1fr; height: 250px;">
    <marquee
      scrollamount="12"
      style="
        grid-row-start: 1;
        grid-column-start: 1;
        text-shadow: 2px 2px
      "
      behavior="alternate"
      ><h5>oliver clark - software engineer</h5>
    </marquee>
    <marquee
      scrollamount="8"
      style="
        grid-row-start: 1;
        grid-column-start: 1;
        text-shadow: 2px 2px orange;
        font-style: italic;
        padding: 75px
      "
      behavior="alternate"
      ><h2>oliver clark - software engineer</h2></marquee
    >
    <marquee
      scrollamount="15"
      style="
        text-shadow: 2px 2px red;
        font-style: oblique;
        grid-row-start: 1;
        grid-column-start: 1;
        padding: 20px
      "
      behavior="alternate"
      direction="right"
      ><h4>oliver clark - software engineer</h4></marquee
    >
    <marquee
      scrollamount="19"
      style="
        grid-row-start: 1;
        grid-column-start: 1;
        text-shadow: 2px 2px;
        padding: 100px
      "
      behavior="alternate"
      direction="right"
      ><h5>oliver clark - software engineer</h5>
    </marquee>
    <marquee
      scrollamount="14"
      behavior="alternate"
      style="
        grid-row-start: 1;
        grid-column-start: 1;
        padding: 50px;
        text-shadow: 2px 2px cyan
      "
      ><h3>oliver clark - software engineer</h3></marquee>

    <img
      src="title.png"
      style="
        grid-row-start: 1;
        grid-column-start: 1;
        max-height: 200px;
        object-fit: contain;
        width: 100%;
      "
    />
    <div class="tab-bar">
      <button
        v-for="item in visibleItems"
        :key="item"
        class="window tab-btn"
        :class="{ 'tab-active': tab === visibleItems.indexOf(item) }"
        @click="selectTab(visibleItems.indexOf(item))"
      >{{ item }}</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "HeaderNE",
  components: {},
  data: () => ({
    isActive: "OC",
    tab: 0,
    items: ["About", "Projects", "Contact"],
  }),
  computed: {
    visibleItems() {
      return this.items.filter((item, index) => index <= 1); // Show "About" and "Projects"
    }
  },
  methods: {
    selectTab(index) {
      this.tab = index;
      this.$emit('tabclick', index);
      this.$emit('tabchange', index);
    }
  },
  props: ["tabs"],
};
</script>
<style src="98.css"></style>
<style scoped>
.tab-bar {
  display: flex;
  width: 100%;
}
.tab-btn {
  flex: 1;
}
.tab-active {
  font-weight: bold;
}
</style>
